<template>
  <main>
    <!-- CVS modal -->
    <b-modal
      id="CVS-modal"
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
      @hidden="$emit('close-modal')"
      :visible="showModal"
    >
      <div class="d-flex align-items-center justify-content-between p-3">
        <div class="b-modal-header">View CVS</div>
        <div class="rotate-on-hover pointer">
          <img
            @click="$emit('close-modal')"
            v-b-tooltip.hover.top="'Close'"
            src="../../../assets/img/accessconnew/blueCross.svg"
            alt
          />
        </div>
      </div>
      <hr class="mt-0" />

      <section class="w-100 d-flex gap-3" style="height: calc(100vh - 312px)">
        <div
          class="
            w-50
            h-100
            d-flex
            align-items-center
            justify-content-center
            px-4
            flex-column
          "
        >
          <div class="d-flex align-items-center justify-content-between w-100">
            <div
              class="d-flex align-items-center gap-2 pointer"
              @click="videoPlaying = !videoPlaying"
            >
              <img
                v-if="!videoPlaying"
                src="../../../assets/img/newkanban/video.svg"
                alt=""
              />

              <img
                v-else
                src="../../../assets/img/newkanban/id-proof.svg"
                alt=""
              />
              <h3 class="vc-blue-txt mt-2">
                <span v-if="videoPlaying">View ID Proof</span
                ><span v-else>View Video</span>
              </h3>
            </div>
          </div>
          <img
            v-if="!videoPlaying"
            class="w-100 h-85"
            :src="cvsData.candidateImage"
            alt="Video thumbnail"
          />
          <template v-else>
            <div
              v-if="!videoProcessed()"
              class="cvs-black-screen-processing h-100 w-95"
            >
              <div class="white-bar-loader">
                <div v-for="i in 8" :key="i"></div>
              </div>
              <div class="text-white-1">Video Processing...</div>
              <div class="text-white-2">Please come back in some time</div>
            </div>
            <video v-else class="w-100 h-85" controls ref="videoPlayer">
              <source :src="cvsData.candidateVideo" type="video/mp4" />
              <!-- Add other source formats if necessary -->
              Your browser does not support the video tag.
            </video>
          </template>
          <!-- <img
          class="w-100"
          src="@/assets/images/PanelistPage/cvs-video.svg"
          alt=""
        /> -->
          <section
            v-if="showMatchBar"
            class="
              d-flex
              cvs-identity-box
              fs-13
              fw-500
              font-lato font-italic
              color-595959
              text-center
              mt-3
            "
            :class="
              !videoPlaying && hasBoth
                ? 'justify-content-between'
                : 'justify-content-center'
            "
          >
            <span
              v-if="cvsData.comparisonScore || cvsData.comparisonScore == 0"
            >
              Face Match Rating:&nbsp;
              <span class="font-normal color-mainblue fw-700 fs-14">
                {{ Math.round(cvsData.comparisonScore) }}%</span
              >
            </span>
            <span v-if="isValidCVSDocument && !videoPlaying">
              ID Type:&nbsp;
              <span class="font-normal color-mainblue fw-700 fs-14">
                {{ cvsData.stats.documentType }}</span
              >
            </span>
          </section>
        </div>
        <div class="w-50 h-100 overflow-xh-ya p-3">
          <section
            class="p-3"
            v-for="(q, i) in cvsData.answerResponse"
            :key="i"
            :class="q.timeStamp && 'ques-hover pointer'"
            @click="q.timeStamp ? vidplay(q.timeStamp) : ''"
          >
            <section class="d-flex align-items-center w-100 gap-2 flex-column">
              <section class="d-flex w-100 gap-1 flex-column">
                <div class="d-flex justify-content-between w-100">
                  <h3 class="question-no-font">Question {{ i + 1 }}:</h3>

                  <div class="pass-card">
                    <img
                      src="../../../assets/img/newkanban/AI-icon.svg"
                      alt=""
                    />
                    {{ showScore(q.score) }}/10
                  </div>
                </div>
                <h2 class="quest-subhead">
                  {{ q.question }}
                </h2>
              </section>

              <section class="d-flex w-100 gap-1 flex-column">
                <h3 class="question-no-font">Answer {{ i + 1 }}:</h3>
                <h2 class="quest-subhead">
                  {{ q.answer.text }}
                </h2>
              </section>

              <hr
                v-if="i < cvsData.answerResponse.length - 1"
                style="background: #a1aebe"
                class="w-100 my-0"
              />
            </section>
          </section>
        </div>
      </section>

      <hr />
      <section
        class="
          d-flex
          align-items-center-w-100
          justify-content-end
          gap-3
          px-4
          pb-3
        "
      >
        <b-button class="acs-cancelBtn-modal mr-3" @click="$emit('close-modal')"
          >Close</b-button
        >
      </section>
    </b-modal>
  </main>
</template>

<script>
export default {
  name: "ViewCvs",
  data() {
    return {
      videoPlaying: false,
      modalType: "",
      headText: "",
      showCommonModal: false,
      showStatLoader: false,
      buttonLoader: false,
    };
  },
  props: {
    showModal: {
      type: Boolean,
    },
    cvsData: Object,
  },
  computed: {
    hasBoth() {
      const hasScore =
        this.cvsData?.comparisonScore === 0 || this.cvsData?.comparisonScore;
      return hasScore && this.isValidCVSDocument;
    },
    showMatchBar() {
      if (this.videoPlaying)
        return (
          this.cvsData.comparisonScore || this.cvsData.comparisonScore == 0
        );
      else {
        return (
          this.cvsData.comparisonScore ||
          this.cvsData.comparisonScore == 0 ||
          this.isValidCVSDocument
        );
      }
    },
    isValidCVSDocument() {
      const { documentType } = this.cvsData.stats;
      return (
        documentType &&
        documentType.toLowerCase() !== "n/a" &&
        documentType.toLowerCase() !== "unknown"
      );
    },
  },
  methods: {
    videoProcessed() {
      if (this.cvsData.stats) return this.cvsData.stats.videoProcessed;
      else return true;
    },
    showScore(score) {
      if (score && score < 10) return `0${score}`;
      else return score;
    },
    playVideo() {
      this.videoPlaying = true; // Show the video player and start playing
      this.$nextTick(() => {
        // Play video once it's rendered
        this.$refs.videoPlayer.play();
      });
    },
    vidplay(value) {
      this.videoPlaying = true;
      this.$nextTick(() => {
        let test = document.querySelectorAll("video");
        let data = value;

        let array = data.split(":");
        const [minutes, seconds] = array.map(Number);
        const totalSeconds = minutes * 60 + seconds;
        for (const item of test) {
          item.currentTime = totalSeconds;
        }
      });
    },
  },
};
</script>

<style scoped>
.viewvideo-font {
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  font-size: 13px;
  color: #20639b;
}
.custom-height {
  height: calc(95% - 30px);
  margin-bottom: 10px;
}

.overflow-xh-ya {
  overflow-x: hidden;
  overflow-y: auto;
}

.ai-card {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 2px 8px;
  gap: 5px;
  background: #f6f9fb;
  border-radius: 4px;
  font-family: "Lato", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  color: #038e00;
}

.overflow-xh-ya {
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
